var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{class:_vm.$style.viewPrivacy},[_c('div',{staticClass:"header__bg"},[_c('BaseBannerTitle',{attrs:{"title":"使用細則＆隱私權條款","sub-title":"Privacy"}})],1),_c('SectionContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }